import React, { useState, useEffect, useCallback, useMemo } from "react";
import "./activeUser.css";
import Portal from "../portal/Portal";
import mqtt from "mqtt";

export default function ActiveUser(props) {
  const userdata = props.logedinuser;
  const cars = userdata.connectionParam.vehicles;
  const [activeVehicle, SetactiveVehicle] = useState("");
  const [activeImei, SetactiveImei] = useState("");
  const [carSelected, setcarSelected] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [goFoward, setgoFoward] = useState(false);
  const vehicles = [];
  const showVehicleNo = () => {
    for (let i = 0; i < cars.length; i++) {
      const j = i * 5;
      vehicles.push(
        <div className="vehicles">
          <h1
            key={i}
            onClick={() => {
              SetactiveVehicle(cars[i].vehicle_no_plate);
              SetactiveImei(cars[i].imei);
              setcarSelected(true);
            }}
          >
            {cars[i].vehicle_no_plate}
          </h1>
          <div
            key={j}
            className="box"
            onClick={() => {
              SetactiveVehicle(cars[i].vehicle_no_plate);
              SetactiveImei(cars[i].imei);
              setcarSelected(true);
            }}
          />
        </div>
      );
    }
  };

  //for mqtt
  const [client, setClient] = useState(null);
  //const [isSubed, setIsSub] = useState("false");
  //const [pubStatus, setpubStatus] = useState("none");
  const [payload, setPayload] = useState({});
  const [connectStatus, setConnectStatus] = useState("Track");

  const record = useMemo(() => ({
    host: userdata.connectionParam.host,
    clientId: `${activeVehicle} + ${Math.random().toString(16).substr(2, 8)} `,
    port: userdata.connectionParam.port,
    username: userdata.connectionParam.userName,
    password: userdata.connectionParam.password,
    topic: [
      `vehicle/${activeImei}/tracker`,
      `vehicle/${activeImei}/speed`,
      `vehicle/${activeImei}/ignition`,
      `vehicle/${activeImei}/state`,
      `vehicle/${activeImei}/battery`,
      `vehicle/${activeImei}/liion`,
      `vehicle/${activeImei}/gsm_level`,
    ],
    qos: 0,
  }), [userdata.connectionParam, activeVehicle, activeImei]);

  //mqtt connect function
  const mqttConnect = (host, mqttOption) => {
    setConnectStatus("Connecting");
    setClient(mqtt.connect(host, mqttOption));
  };

  const handleConnection = async () => {
    const { host, clientId, port, username, password } = record;
    const url = `wss://${host}:${port}/mqtt`;
    const options = {
      keepalive: 30,
      protocolId: "MQTT",
      protocolVersion: 4,
      clean: true,
      reconnectPeriod: 1000,
      connectTimeout: 30 * 1000,
      will: {
        topic: "WillMsg",
        payload: "Connection Closed abnormally..!",
        qos: 0,
        retain: false,
      },
      rejectUnauthorized: false,
    };
    options.clientId = clientId;
    options.username = username;
    options.password = password;
    mqttConnect(url, options);
  };
  const mqttDisconnect = async () => {
    if (client) {
      client.end(() => {
        setConnectStatus("Disconnected client");
      });
    }
  };
  const mqttSub = useCallback((subscription) => {
    if (client) {
      const { topic, qos } = subscription;
      for (let v = 0; v < topic.length; v++) {
        client.subscribe(topic[v], { qos }, (error) => {
          if (error) {
            console.log("Subscribe to topics error", error);
          }
        });
      }
    }
  }, [client]);
  const mqttUnSub = (subscription) => {
    if (client) {
      const { topic } = subscription;
      client.unsubscribe(topic, (error) => {
        if (error) {
          console.log("Unsubscribe error", error);
          return;
        }
        //setIsSub(false);
      });
    }
  };
  const mqttPublish = (context) => {
    if (client) {
      const { topic, qos, command } = context;
      client.publish(topic, command, { qos }, (error) => {
        if (error) {
          console.log("Publish error: ", error);
          //setpubStatus("error publishing");
        } else {
          //setpubStatus("publish success");
        }
      });
    } else {
      //setpubStatus("publish error: client not ready");
    }
  };

  showVehicleNo();
  const handleTrack = (e) => {
    e.preventDefault();
    if (carSelected === false) {
      setErrorMessage("! Please select car first");
    } else {
      handleConnection();
    }
  };

  useEffect(() => {
    if (client) {
      client.on("connect", () => {
        setConnectStatus("Connected");
        mqttSub(record); // Now `mqttSub` and `record` are stable
        setgoFoward(true);
      });
      client.on("error", (err) => {
        console.error("Connection error: ", err);
        client.end();
      });
      client.on("reconnect", () => {
        setConnectStatus("Reconnecting");
      });
      client.on("message", (topic, message) => {
        const payload = { topic, message: message.toString() };
        setPayload(payload);
      });
    }
  }, [client, mqttSub, record]); // Now the dependencies are stable
  

  return (
    <div>
      {!goFoward ? (
        <div className="activeuser">
          <div className="holderyaactive">
            <h1>Welcome Back {userdata.userName} </h1>
            <h2>please select a car</h2>
            <ul>
              <div className="spacer2" />
              {vehicles}
            </ul>
            <div className="action">
              <h1 className="display">{activeVehicle}</h1>
              <button onClick={handleTrack}>{connectStatus}</button>
              <div className="errormessage">{errorMessage}</div>
            </div>
            <div className="spacerr" />
          </div>
        </div>
      ) : (
        <Portal
          logedinuser={userdata}
          payload={payload}
          publish={mqttPublish}
          unSub={mqttUnSub}
          disconnect={mqttDisconnect}
          activeVehicle={activeVehicle}
          activeImei={activeImei}
        />
      )}
    </div>
  );
}
